import services from "../../../data/services.json";
import servicesPrice from "../../../data/services-price.json";
import { Color } from "../style";

export type Service = {
  id: string;
  anchorId: string;
  title: string;
  color: Color;
  expectedStart?: string;
  shortDescription: string;
  shortHTMLDescription: string;
  description: string;
};

type ServicePrice = {
  serviceId?: string;
  title: string;
  duration: number[] | 0;
  price: number;
  priceUnit?: string;
  pass: {
    occasion: number;
    price: number;
  }[];
  passIncludesFreeConsultation?: boolean;
  comment?: string;
  commentConsultation?: boolean;
};

export function getAllService(): Service[] {
  return [...services] as Service[];
}

export function getService(id: string): Service | null {
  return (
    (services.find(
      (service) => service.id === id || service.anchorId === id
    ) as Service) || null
  );
}

export function getServicesWithRegexes(): {
  regex: RegExp;
  service: Service;
}[] {
  return (services as Service[]).map((service) => ({
    regex: new RegExp("^(.*)(" + service.title + ")(.*)$", "i"),
    service,
  }));
}

export function getAllServicePrice(): ServicePrice[] {
  return [...servicesPrice] as ServicePrice[];
}
